export default __webpack_public_path__ + "static/media/back2.ac743e66.jpg";